module.exports = __webpack_public_path__ + "static/media/STARS.866385cf.svg";